import { Component } from "@angular/core";
import { UiTabPosition } from "@webapp/ui/tab/models/tab.models";
@Component({
  selector: "gh-example-tab-component",
  templateUrl: "./example-tab.component.html",
  styleUrls: ["./example-tab.component.less"],
})
export class ExampleTabComponent {
  public tabs = ["Tab 1", "Tab 2", "Tab 3", "Tab 4", "Tab 5", "Tab 6", "Tab 7"];
  public selectedIndex = 0;
  public tabsWithIcons = [
    {
      name: "Tab 1",
      icon: "outline:apple",
    },
    {
      name: "Tab 2",
      icon: "outline:android",
    },
  ];
  public position: UiTabPosition = "top";
  public tabsWithPossition = [1, 2, 3];
  public options = [
    { value: "top", label: "top" },
    { value: "left", label: "left" },
    { value: "right", label: "right" },
    { value: "bottom", label: "bottom" },
  ];

  public closeTab({ index }: { index: number }): void {
    this.tabs.splice(index, 1);
  }

  public newTab(): void {
    this.tabs.push("New Tab");
    this.selectedIndex = this.tabs.length;
  }
}
